import React, { useState } from 'react'
import { Button } from '../Button/Button'
import clsx from 'clsx'

export const SwipeElement = ({ onNextStep, data }: { onNextStep: () => void; data: any }) => {
  const [result, setResult] = useState(null)

  const handlerResult = (result: any) => {
    setResult(result)
    setTimeout(() => {
      onNextStep()
    }, 1000)
  }

  return (
    <div className="mt-5">
      <div className="relative">
        <img
          className={clsx(
            'w-full px-4 transition-all duration-200',
            {
              'opacity-0': result,
            },
            data?.classes,
          )}
          src={data.src}
          width={200}
          height={200}
          alt="swipe image"
        />
        <div
          className={clsx(
            'absolute top-1/2 transition-all duration-200 delay-150 opacity-0 left-1/2 -translate-x-1/2 -translate-y-1/2 w-32 h-32 rounded-full flex items-center justify-center text-base font-semibold leading-[1.5]',
            {
              'border border-[#C6C8CF] text-[#101A36]': result === 'No',
              ' bg-[#101A36] text-[white]': result === 'Yes',
              ' opacity-100': result,
            },
            data?.classes,
          )}
        >
          {result}
        </div>
      </div>
      <p className="text-center mt-4 text-[14px] font-medium leading-[22px] text-[#101A36B2]">
        {data.text}
      </p>
      <div
        className={clsx(
          'flex gap-2.5 mt-6',
          {
            'pointer-events-none': result,
          },
          data?.classes,
        )}
      >
        <Button className="max-w-full w-full" onClick={() => handlerResult('No')} variant="large">
          No
        </Button>
        <Button
          className="max-w-full w-full"
          onClick={() => handlerResult('Yes')}
          variant="largeFill"
        >
          Yes
        </Button>
      </div>
    </div>
  )
}
